module.exports = __webpack_public_path__ + "img/horse.1f64a658.png";